import React from 'react';
import { styled } from '@mui/material/styles';
import { PAGING_END_INDEX } from '../../utilities/staticConfigs';
import { Box } from '@mui/material';

const PaginateContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '16px 0',
  justifyContent: 'flex-end',
});

const PageButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
  minWidth: '32px',
  height: '32px',
  padding: '0 6px',
  borderRadius: '4px',
  border: '1px solid',
  borderColor: active ? theme.palette.primary.darker : '#d1d1d1',
  backgroundColor: active ? theme.palette.primary.darker : 'transparent',
  color: active ? '#fff' : theme.palette.text.primary,
  cursor: 'pointer',
  fontSize: '0.875rem',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: active ? theme.palette.primary.higlight : 'rgba(0, 0, 0, 0.04)',
  },
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
    borderColor: '#e0e0e0',
  },
}));


const Pagination = (props) => {
  const { activePage, totalPage, startIndex, endIndex, onPagePrevious, onPageUp, onPageNext } = props;
  const pageNumbers = Array.from({ length: totalPage }, (_, i) => i + 1);
  if (pageNumbers.length <= 1) return null;

  return (
    <PaginateContainer>
      <PageButton
        disabled={activePage === 1 || endIndex - PAGING_END_INDEX <= 1}
        onClick={(e) => onPagePrevious(e)}
        data-testid="prev-page-btn"
      >
        &lt;
      </PageButton>

      {pageNumbers.slice(startIndex, endIndex).map((number) => (
        <PageButton
          key={number}
          id={number}
          active={activePage === number}
          onClick={(e) => onPageUp(e)}
          data-testid={`page-${number}-btn`}
        >
          {number}
        </PageButton>
      ))}

      <PageButton
        disabled={activePage === totalPage || startIndex + PAGING_END_INDEX >= totalPage}
        onClick={(e) => onPageNext(e)}
        data-testid="next-page-btn"
      >
        &gt;
      </PageButton>
    </PaginateContainer>
  );
};

export default Pagination;